import appointmentService from "../../../../services/appointmentService";
import holidayService from "../../../../services/holidayCalendar";
import moment from "moment";
import pageheader from "../../../pageheader";
import utils from "../../../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "new-appointment",
  components: { pageheader },
  props: [],
  data() {
    return {
      input: {},
      event: "",
      eventID: this.$route.params.eventId,
      referenceID: "",
      location: "",
      successMessage: "",
      showParticipantsSection: false,
      nowDate: new Date().toISOString().slice(0, 10),
      date: new Date().toISOString().substr(0, 10),
      addAppointmentPayload: {},
      tSlots: [],
      pickerDate: "",
      selectedTimings: "",
      selectedMonth: "",
      dialog: false,
      selectedSlotIndex: null,
      isslotSelected: false,
      isLoading: false,
      eventName: "",
      userInformation: [
        {
          firstName: "",
          lastName: "",
          email: "",
        },
      ],
      userTimeZone: "America/New_York",
      isslotsLoading: false,
      availableDates: [],
      holidaysList: [],
      selectedYear: new Date().getFullYear(),
      eventHolidayCalendarOptIn: this.$store.state.user
        .selectedEventHolidayCalendarOptIn,
      openedPanel: [],
      isExpanded: false,
      showbanner: true,
      showSelectSlotsMessage: false,
    };
  },
  filter: {
    trimSeconds(dateString) {
      if (dateString) {
        return moment(dateString).format("hh:mm");
      } else {
        return "";
      }
    },
    lowercase: function(value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  watch: {
    pickerDate(newval) {
      this.getSlots(newval);
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  created() {
    this.loadHolidays();
  },
  mounted() {
    this.input = utils.getInputContent("booknewappointment", this.roles);
    this.eventName = this.$store.getters.eventTitle;
    this.location = this.$store.getters.eventLocation;
  },
  methods: {
    backToEvents() {
      this.$router.push("/events/all");
    },
    dateChanged() {
      this.showSelectSlotsMessage = false;
      this.isslotsLoading = true;
      this.selectedSlotIndex = null;
      this.showParticipantsSection = false;
      this.userInformation = [
        {
          name: "",
          email: "",
        },
      ];
      this.filterSlots();
    },
    getSlots(selectedDate) {
      this.isslotsLoading = true;
      let dateSlpit = selectedDate.split("-");
      this.selectedMonth = dateSlpit[1];
      this.selectedYear = dateSlpit[0];

      appointmentService.getAvailabilityForAppointment(
        this,
        (data) => {
          if (data) {
            data.availabilityTimeslots.map((dataItem) => {
              dataItem.slots.map((slotItem) => {
                slotItem.fromTime = slotItem.fromTime.substr(0, 5);
                slotItem.toTime = slotItem.toTime.substr(0, 5);
              });
            });
            this.slots = JSON.parse(JSON.stringify(data));
            this.filterSlots();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    filterSlots() {
      this.tSlots = [];
      var momentDate = moment(this.date).format("MM/DD/YYYY");
      let mMonth = moment(momentDate).format("MM");
      let mDate = moment(momentDate).format("DD");
      let mYear = moment(momentDate).format("YYYY");
      if (this.slots) {
        let mSlots = this.slots["availabilityTimeslots"];
        let filterSlots = [];
        for (var i in mSlots) {
          let filterMonth = moment(mSlots[i].eventDate).format("MM");
          let filterDate = moment(mSlots[i].eventDate).format("DD");
          let filterYear = moment(mSlots[i].eventDate).format("YYYY");
          if (
            filterMonth == mMonth &&
            filterDate == mDate &&
            mYear == filterYear
          ) {
            filterSlots.push(mSlots[i]);
          }
        }
        this.tSlots = filterSlots.length > 0 ? filterSlots[0].slots : "";
        setTimeout(() => {
          this.isslotsLoading = false;
        }, 1000);
      }
    },
    addPerson() {
      this.userInformation.push({ name: "", email: "" });
    },
    removePerson(index) {
      this.userInformation.splice(index, 1);
    },
    onSlotSelect(option, slotitem) {
      this.showParticipantsSection = true;
      this.selectedSlotIndex = option;
      //this.isslotSelected = false;
      this.isslotSelected = true;
      this.selectedTimings = slotitem;
      console.log(" this.selectedTimings", this.selectedTimings);
    },
    bookAppointment() {
      if (!this.isslotSelected) {
        this.$toast.error("Please select the time slot");
      } else if (this.location == "") {
        this.$toast.error("Please Add the location");
      } else {
        this.isLoading = true;
        this.addAppointmentPayload = {
          eventId: this.$route.params.eventId,
          eventDate: this.date,
          startTime: this.selectedTimings.fromTime,
          endTime: this.selectedTimings.toTime,
          attendees: this.userInformation,
          referenceId: this.referenceID,
          location: this.location,
          timeZoneId: this.userTimeZone,
        };

        appointmentService.createAppointmentForEvent(
          this,
          (data) => {
            this.isLoading = false;
            if (data.isSuccess) {
              this.successMessage = "Appointment booked successfully";
              this.dialog = true;
            } else {
              this.$toast.error(data.systemMessage);
            }
          },
          (error) => {
            console.log(error);
            this.isLoading = false;
            this.$toast.error(
              "Unable to book the appointment. Please try again later"
            );
          }
        );
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$router.push({
        name: "Events",
      });
    },
    allowedDates(a) {
      return this.availableDates.includes(a);
    },

    pickerUpdate: function(val) {
      this.selectedYear = val.split("-")[0];
      if (new Date().toISOString().substr(0, 7) != val) {
        this.tSlots = [];
        this.showSelectSlotsMessage = true;
      } else {
        this.showSelectSlotsMessage = false;
      }
      this.loadHolidays();

      setTimeout(() => {
        let totalDay = moment(val, "YYYY-MM").daysInMonth();
        let availableDates = [];

        let monthNow = moment().format("M");
        let monthSelected = moment(val).format("M");
        let day;

        if (monthNow == monthSelected) {
          day = moment().format("D");
        } else {
          day = 1;
        }

        //iterate through month days and exclude the weekends
        for (let i = day; i <= totalDay; i++) {
          let date = moment()
            .month(val.split("-")[1] - 1)
            .year(val.split("-")[0])
            .date(i)
            .format("YYYY-MM-DD");
          if (moment(date).day() !== 0 && moment(date).day() !== 6) {
            //Below are the moment JS integer values for weekdays
            //sunday-0
            //saturday-6
            availableDates.push(date);
          }
        }
        this.availableDates = availableDates;

        //check if Event integrates Holiday Dates as well and exclude holidays accordingly
        if (this.eventHolidayCalendarOptIn) {
          //exclude holidays to the list
          this.holidaysList.map((item) => {
            if (this.availableDates.includes(item)) {
              //if holiday exist in allowed dates list then remove it
              for (var i = 0; i < this.availableDates.length; i++) {
                if (this.availableDates[i] == item) {
                  this.availableDates.splice(i, 1);
                }
              }
            }
          });
        }
        this.allowedDates();
      }, 2000);
    },
    loadHolidays() {
      holidayService.getHolidays(
        this,
        (response) => {
          if (response.isSuccess) {
            this.holidaysList = [];
            response.holidays.map((item) => {
              this.holidaysList.push(moment(item.date).format("YYYY-MM-DD"));
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
  },
};
